import { render, staticRenderFns } from "./yh_shuang.vue?vue&type=template&id=1cc6ba66&scoped=true"
import script from "./yh_shuang.vue?vue&type=script&lang=js"
export * from "./yh_shuang.vue?vue&type=script&lang=js"
import style0 from "./yh_shuang.vue?vue&type=style&index=0&id=1cc6ba66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6ba66",
  null
  
)

export default component.exports